import React from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import PropTypes from "prop-types";
import { Icon } from "@mui/material";

function EmailVerification({
  emailData,
  index,
  onSendOTP,
  onFieldChange,
  onVerify,
  onUnlinked,
  isSendingOTP,
}) {
  const isEmailValid = (email) => {
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailPattern.test(email);
  };

  return (
    <MDBox key={index} mb={2} style={{ display: emailData.isVerified && "flex" }}>
      <MDBox style={{ display: "flex" }} mb={2}>
        <MDInput
          required
          type="email"
          label="Email"
          name="email"
          variant="outlined"
          value={emailData.email}
          disabled={emailData.disabled || emailData.isVerified}
          onChange={(e) => onFieldChange(e, index)}
          error={!isEmailValid(emailData.email)}
        />
        {!emailData.isVerified && (
          <MDButton
            variant="text"
            color="info"
            onClick={() => onSendOTP(index)}
            disabled={emailData.isVerified || isSendingOTP || !isEmailValid(emailData.email)}
          >
            {isSendingOTP ? "Sending Verification Code..." : "Send Verification Code"}
          </MDButton>
        )}
      </MDBox>
      {emailData.isOTPVisible && (
        <MDBox>
          {!emailData.isVerified && (
            <MDInput
              type="number"
              label="Verification Code"
              variant="outlined"
              name="otpNumber"
              value={emailData.otpNumber}
              onChange={(e) => onFieldChange(e, index)}
            />
          )}

          {emailData.isVerified ? (
            <>
              <MDButton
                variant="text"
                color="success"
                sx={{ cursor: "default", pointerEvents: "none" }}
              >
                Verified
              </MDButton>
              <Icon color="success">checkcircle</Icon>
            </>
          ) : (
            <MDButton
              variant="text"
              color="info"
              onClick={() => onVerify(index)}
              disabled={!emailData.otpNumber}
            >
              Verify
            </MDButton>
          )}
        </MDBox>
      )}
    </MDBox>
  );
}

// Define prop types
EmailVerification.propTypes = {
  emailData: PropTypes.shape({
    email: PropTypes.string,
    isOTPVisible: PropTypes.bool,
    otpNumber: PropTypes.string,
    disabled: PropTypes.bool,
    isVerified: PropTypes.bool,
    isAuthFlow: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number.isRequired,
  onSendOTP: PropTypes.func,
  onFieldChange: PropTypes.func.isRequired,
  onVerify: PropTypes.func.isRequired,
  onUnlinked: PropTypes.func.isRequired,
  isSendingOTP: PropTypes.bool,
};

export default EmailVerification;
